export default "/images/fc76e3d5ff427bb00a2da396ed5ebb64.avif";